module.exports = __webpack_public_path__ + "img/Nicaragua.08a2995d.svg";